import { createReducer, on } from '@ngrx/store';
import * as projectLocationsActions from './project-locations.action';
import { projectLocationState } from './project-locations.state';

const projectLocationReducer = createReducer(
  projectLocationState,
  on(projectLocationsActions.getProjectLocationsSuccess, (state, action) => ({
    ...state,
    projectLocations: action.payload,
  })),
  on(projectLocationsActions.getProjectLocationsCancel, (state) => ({
    ...state,
    projectLocations: [],
  }))
);

export default projectLocationReducer;
